import React__default from 'react';
import { BsGeo } from '@react-icons/all-files/bs/BsGeo';
import { EditorPlaceholder } from '../../../components/EditorPlaceholder/EditorPlaceholder.js';
import 'lodash-es';
import '@bucketplace/ui';
import { useEditor } from '../../../hooks/useEditor.js';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import '../../../contexts/internal/EditorContext.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';

function AnchorTarget(_ref) {
  var targetId = _ref.targetId;
  var _useEditor = useEditor(),
    displayMode = _useEditor.state.displayMode;
  var AnchorContents = displayMode === 'view' ? jsx(React__default.Fragment, null) : jsx(EditorPlaceholder, {
    message: "".concat(targetId, "\uB85C \uC575\uCEE4 URL \uC124\uC815\uC2DC \uC5EC\uAE30\uB85C \uC2A4\uD06C\uB864\uB429\uB2C8\uB2E4")
  });
  return jsx("div", {
    id: targetId,
    "data-testid": targetId
  }, targetId != null && targetId !== '' ? AnchorContents : jsx(EditorPlaceholder, {
    icon: jsx(BsGeo, null),
    message: "\uC575\uCEE4 \uD0C0\uCF13 id\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694"
  }));
}

export { AnchorTarget };
//# sourceMappingURL=AnchorTarget.js.map
